import React from 'react';
import PropTypes from 'prop-types';

const ListItem = props => (
    <li className="list__item">
        {props.children}
    </li>
);

ListItem.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/frontend/components/List/ListItem.jsx